var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_10145)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7.75,
    fill: "#6A6F7B",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.75,
    fill: "#17181C",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3865 9.1095C10.3865 10.05 9.712 10.8575 8.439 11.0475V12.045H7.3275V11.057C6.216 10.905 5.4465 10.221 5.285 9.119H6.4725C6.6245 9.708 7.1185 10.0595 7.8405 10.0595C8.781 10.0595 9.1705 9.651 9.1705 9.1095C9.1705 7.6275 5.5035 8.7675 5.5035 6.1455C5.5035 5.1765 6.1875 4.4545 7.3275 4.293V3.305H8.439V4.3025C9.484 4.483 10.092 5.1575 10.244 6.079H9.0565C8.9235 5.6135 8.534 5.2905 7.869 5.2905C7.09 5.2905 6.7195 5.68 6.7195 6.1455C6.7195 7.694 10.3865 6.611 10.3865 9.1095Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_10145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCurrency);
export default __webpack_public_path__ + "static/media/multiCurrency.821258cc6177740f79c7fc6f6780ef11.svg";
export { ForwardRef as ReactComponent };